/* rittencom.js */
(function () {
  'use strict';

  // -------------------------------------------------
  // PROOF OF LIFE (always logs)
  // -------------------------------------------------
  (function () {
    var v = 'rittencom.js v2026-02-07a';
    var qs0 = (location && location.search) ? location.search : '';
    try { console.log('[rittencom] LOADED', v, qs0); } catch (_) {}
  })();

  /* =====================================================================
    CORE FEATURES CHECKLIST (DO NOT REMOVE)
    1) initUntaxedSubtotalAndFreeShipping()
       - Cart drawer: updates [data-untaxed-subtotal] and .free-shipping-bar progress/message
    2) initCollectionExcerpts()
       - Collection pages: adds "Læs mere / Læs mindre" toggles per .collection__description
    3) registerImpulseSections()
       - Ensures theme.sections.register('product', ...) is executed for Impulse integration
    4) initCartRecsBar()
       - Desktop: portals .cart-recs-bar to <body>, sets --cart-drawer-width, prevents drawer-close clicks
  ====================================================================== */

  // -------------------------------------------------
  // Namespace + singleton guard (versioned)
  // -------------------------------------------------
  var rittencom = (window.rittencom = window.rittencom || {});
  var __V = '2026-02-07a';

  if (rittencom.__INITED__ && rittencom.__INITED_VERSION__ === __V) return;
  rittencom.__INITED__ = true;
  rittencom.__INITED_VERSION__ = __V;

  rittencom.qs = rittencom.qs || {};
  rittencom.qs.nativeBridge = true;
  window.__RITTENCOM_QS_NATIVE_BRIDGE__ = true;

  // -------------------------------------------------
  // Helpers
  // -------------------------------------------------
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function cssEscape(s) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
    return (s || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function portalize(el) {
    if (!el) return el;
    if (document.body && el.parentElement !== document.body) document.body.appendChild(el);
    return el;
  }

  function safeNumber(n, fallback) {
    var x = Number(n);
    return Number.isFinite(x) ? x : (fallback || 0);
  }

  function stopAll(e) {
    if (!e) return;
    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    if (typeof e.stopImmediatePropagation === 'function') {
      try { e.stopImmediatePropagation(); } catch (_) {}
    }
  }

  function hasImpulseModalApi() {
    return (window.theme && typeof window.theme.Modals === 'function');
  }

  function getProductIdFromTriggerClass(el) {
    if (!el || !el.classList) return '';
    for (var i = 0; i < el.classList.length; i++) {
      var c = el.classList[i];
      var m = /^js-modal-open-quick-modal-(\d+)$/.exec(c);
      if (m && m[1]) return m[1];
    }
    return '';
  }

  function normalizeHandle(raw) {
    if (!raw) return '';
    var h = String(raw).trim();
    h = h.replace(/^https?:\/\/[^/]+/i, '');
    h = h.replace(/^\/+/, '');
    h = h.replace(/^products\//, '');
    h = h.replace(/^\/?products\//, '');
    h = h.split('?')[0].split('#')[0];
    return h;
  }

  function getProductIdFromDataAttrs(el) {
    if (!el) return '';
    var ds = el.dataset || {};

    var keys = [
      'productId',
      'productid',
      'product_id',
      'clerkProductId',
      'clerk_product_id',
      'id',
      'pid'
    ];

    for (var i = 0; i < keys.length; i++) {
      var v = ds[keys[i]];
      if (v && /^\d+$/.test(String(v))) return String(v);
    }

    var attrCandidates = [
      'data-product-id',
      'data-productid',
      'data-product_id',
      'data-clerk-product-id',
      'data-clerk_product_id',
      'data-pid'
    ];
    for (var j = 0; j < attrCandidates.length; j++) {
      var av = el.getAttribute && el.getAttribute(attrCandidates[j]);
      if (av && /^\d+$/.test(String(av))) return String(av);
    }

    return '';
  }

  function getProductIdFromAny(el) {
    var cur = el;
    for (var i = 0; i < 7 && cur; i++) {
      var pid1 = getProductIdFromTriggerClass(cur);
      if (pid1) return pid1;

      var pid2 = getProductIdFromDataAttrs(cur);
      if (pid2) return pid2;

      cur = cur.parentElement;
    }
    return '';
  }

  function extractHandleNearQuickButton(btn) {
    if (!btn) return '';

    var h1 = normalizeHandle(
      (btn.getAttribute && btn.getAttribute('data-product-handle')) ||
      (btn.dataset && (btn.dataset.productHandle || btn.dataset.producthandle))
    );
    if (h1) return h1;

    var card = btn.closest ? btn.closest('[data-product-handle]') : null;
    if (card) {
      var h2 = normalizeHandle(
        (card.getAttribute && card.getAttribute('data-product-handle')) ||
        (card.dataset && (card.dataset.productHandle || card.dataset.producthandle))
      );
      if (h2) return h2;
    }

    try {
      var scope = btn.closest && btn.closest('[data-product-id], .grid-product, .product-grid-item, .product-grid');
      if (scope) {
        var a = scope.querySelector('a[href*="/products/"]');
        if (a) {
          var href = a.getAttribute('href') || '';
          var m = href.match(/\/products\/([^/?#]+)/);
          if (m && m[1]) return normalizeHandle(m[1]);
        }
      }
    } catch (_) {}

    var pid = getProductIdFromAny(btn);
    if (pid) {
      var fromModal = extractHandleFromModal(pid, btn);
      if (fromModal) return fromModal;
    }

    return '';
  }

  // -------------------------------------------------
  // waitFor helper
  // -------------------------------------------------
  function waitFor(checkFn, opts) {
    opts = opts || {};
    var timeout = opts.timeout || 8000;
    var interval = opts.interval || 50;
    var label = opts.label || 'waitFor';

    return new Promise(function (resolve, reject) {
      var start = Date.now();
      var t = setInterval(function () {
        var val = false;
        try { val = checkFn(); } catch (e) { clearInterval(t); reject(e); return; }
        if (val) { clearInterval(t); resolve(val); return; }
        if (Date.now() - start > timeout) {
          clearInterval(t);
          reject(new Error(label + ' timeout after ' + timeout + 'ms'));
        }
      }, interval);
    });
  }

  // -------------------------------------------------
  // Click de-dupe helpers
  // -------------------------------------------------
  function markEventHandled(e, key) {
    if (!e) return false;
    var prop = '__rittencom_handled__';
    if (e[prop]) return false;
    e[prop] = key || true;
    return true;
  }

  // Debug toggles
  var DEBUG_FACTS = Boolean(
    window.RITTENCOM_DEBUG ||
    /(?:\?|&)rittencomdebug=1\b/i.test((location && location.search) || '') ||
    /(?:#|&)rittencomdebug=1\b/i.test((location && location.hash) || '')
  );

  function flog() {
    if (!DEBUG_FACTS || !console || !console.log) return;
    console.log.apply(console, ['[rittencom]'].concat([].slice.call(arguments)));
  }

  // -------------------------------------------------
  // Internal state
  // -------------------------------------------------
  var STATE = (rittencom.__STATE__ = rittencom.__STATE__ || {});
  STATE.qs = STATE.qs || { inited: false, mutexUntil: 0, lastOpenByPid: {}, preloadByPid: {} };
  STATE.cartRecs = STATE.cartRecs || { inited: false };
  STATE.subtotalObs = STATE.subtotalObs || { inited: false, observer: null };
  STATE.clerkRecsBridge = STATE.clerkRecsBridge || { inited: false };
  STATE.clerkQuickView = STATE.clerkQuickView || { inited: false };
  STATE.qsInterceptor = STATE.qsInterceptor || { inited: false };
  STATE.sections = STATE.sections || { registered: false };
  STATE.main = STATE.main || { inited: false };

  STATE.modal = STATE.modal || {
    activeId: '',
    prevFocus: null,
    keydownBound: false,
    suppressClickUntil: 0,
    suppressClickPid: ''
  };

  function isMutexLocked() {
    return safeNumber(STATE.qs.mutexUntil, 0) > Date.now();
  }
  function lockMutex(ms) {
    STATE.qs.mutexUntil = Date.now() + safeNumber(ms, 900);
  }

  function shouldThrottleOpen(productId) {
    productId = String(productId || '');
    if (!productId) return false;

    var now = Date.now();
    var last = STATE.qs.lastOpenByPid ? STATE.qs.lastOpenByPid[productId] : 0;
    if (last && (now - last) < 650) return true;

    STATE.qs.lastOpenByPid = STATE.qs.lastOpenByPid || {};
    STATE.qs.lastOpenByPid[productId] = now;
    return false;
  }

  // -------------------------------------------------
  // Public API
  // -------------------------------------------------
  rittencom.addItemsToCart = addItemsToCart;
  rittencom.init = init;

  if (!window.addItemsToCart) window.addItemsToCart = addItemsToCart;

  // -------------------------------------------------
  // Feature: Add items to cart
  // -------------------------------------------------
  function addItemsToCart(el, variantIdArray) {
    if (!el) return;

    el.classList.add('btn--loading');

    var newVariantIdArray = (variantIdArray || '').toString().split(',');

    var product_data = newVariantIdArray
      .map(function (variantId) {
        var parts = (variantId || '').split(':');
        var id = (parts[0] || '').trim();
        var qty = (parts[1] || '').trim();
        return { id: id, quantity: qty };
      })
      .filter(function (x) { return x && x.id && x.quantity; })
      .map(function (x) { return { id: Number(x.id), quantity: Number(x.quantity) }; })
      .filter(function (x) { return Number.isFinite(x.id) && Number.isFinite(x.quantity) && x.quantity > 0; });

    if (!product_data.length) {
      el.classList.remove('btn--loading');
      return;
    }

    fetch('/cart/add.js', {
      body: JSON.stringify({ items: product_data }),
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
      method: 'POST'
    })
      .then(function (response) { return response.json(); })
      .then(function () {
        el.classList.remove('btn--loading');
        if (window.theme && theme.CartDrawer) {
          var cart = new theme.CartDrawer();
          cart.init();
          cart.open();
        }
      })
      .catch(function (err) {
        el.classList.remove('btn--loading');
        console.error(err);
      });
  }

  // -------------------------------------------------
  // Modal helpers (generic open/close)
  // -------------------------------------------------
  function deactivateModal(modal) {
    if (!modal) return;

    try {
      var ae = document.activeElement;
      if (ae && modal.contains(ae) && typeof ae.blur === 'function') ae.blur();
    } catch (_) {}

    try { modal.classList.remove('modal--is-active'); } catch (_) {}
    try { modal.setAttribute('aria-hidden', 'true'); } catch (_) {}
  }

  function closeAllModalsExcept(keepId) {
    var keep = keepId ? String(keepId) : '';
    var mods = qsa('.modal.modal--is-active, .modal[aria-hidden="false"]');
    for (var i = 0; i < mods.length; i++) {
      var m = mods[i];
      if (keep && m && m.id === keep) continue;
      deactivateModal(m);
    }
    if (!keep) {
      document.documentElement.classList.remove('modal-open');
      try { document.body.classList.remove('modal-open'); } catch (_) {}
    }
  }

  function closeCartDrawerIfOpen() {
    try { document.dispatchEvent(new CustomEvent('cart:close', { bubbles: true })); } catch (_) {}
  }

  function ensureGlobalEscapeHandler() {
    if (STATE.modal.keydownBound) return;
    STATE.modal.keydownBound = true;

    document.addEventListener('keydown', function (e) {
      if (!e) return;
      if (e.key !== 'Escape' && e.key !== 'Esc') return;

      var activeId = STATE.modal.activeId;
      if (!activeId) return;

      var modalEl = document.getElementById(activeId);
      if (!modalEl) {
        STATE.modal.activeId = '';
        return;
      }

      stopAll(e);
      closeModal(modalEl);
    }, true);
  }

  function isCloseTrigger(t) {
    if (!t || !t.closest) return false;
    return !!(
      t.closest('.js-modal-close') ||
      t.closest('.modal__close') ||
      t.closest('[data-close-modal]') ||
      t.closest('button[aria-label="Close"]')
    );
  }

  function bindModalCloseOnce(modalEl) {
    if (!modalEl) return;
    if (modalEl.__rittencom_close_bound__) return;
    modalEl.__rittencom_close_bound__ = true;

    modalEl.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (isCloseTrigger(t)) {
        stopAll(e);
        closeModal(modalEl);
        return;
      }

      var inContent = !!t.closest('.modal__centered-content');
      var clickedBackdrop =
        (t === modalEl) ||
        (t.classList && t.classList.contains('modal__inner')) ||
        (t.classList && t.classList.contains('modal__centered'));

      if (!inContent && clickedBackdrop) {
        stopAll(e);
        closeModal(modalEl);
        return;
      }

      // If add-to-cart is triggered from quick shop, close modal to avoid UI overlap with cart drawer.
      var addToCartBtn = t.closest(
        '[data-add-to-cart], button[name="add"], form[action*="/cart/add"] [type="submit"]'
      );
      if (addToCartBtn && !addToCartBtn.disabled) {
        setTimeout(function () { closeModal(modalEl); }, 40);
      }
    }, true);

    modalEl.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      setTimeout(function () { closeModal(modalEl); }, 40);
    }, true);
  }

  function dispatchModalLifecycle(mid, isOpen, modalEl) {
    if (!mid) return;
    var evtName = (isOpen ? 'modalOpen.' : 'modalClose.') + mid;
    try {
      document.dispatchEvent(new CustomEvent(evtName, {
        bubbles: true,
        detail: { modalId: mid, modal: modalEl || null }
      }));
      flog('modal:lifecycle', { event: evtName });
    } catch (_) {}
  }

  function openModal(modalEl, triggerEl) {
    if (!modalEl) return false;

    ensureGlobalEscapeHandler();
    bindModalCloseOnce(modalEl);

    try { STATE.modal.prevFocus = document.activeElement || null; } catch (_) { STATE.modal.prevFocus = null; }

    var mid = modalEl.id || '';
    closeAllModalsExcept(mid);
    closeCartDrawerIfOpen();

    portalize(modalEl);

    document.documentElement.classList.add('modal-open');
    try { document.body.classList.add('modal-open'); } catch (_) {}

    modalEl.classList.add('modal--is-active');
    try { modalEl.setAttribute('aria-hidden', 'false'); } catch (_) {}
    if (modalEl.style && modalEl.style.display === 'none') modalEl.style.display = '';

    if (triggerEl && triggerEl.setAttribute && mid) {
      try { triggerEl.setAttribute('aria-expanded', 'true'); } catch (_) {}
      try { triggerEl.setAttribute('aria-controls', mid); } catch (_) {}
    }

    if (mid) STATE.modal.activeId = mid;

    try {
      var closeBtn =
        modalEl.querySelector('.js-modal-close') ||
        modalEl.querySelector('.modal__close') ||
        modalEl.querySelector('[data-close-modal]') ||
        modalEl.querySelector('button[aria-label="Close"]');

      var focusTarget =
        closeBtn ||
        modalEl.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    } catch (_) {}

    dispatchModalLifecycle(mid, true, modalEl);

    return true;
  }

  function closeModal(modalEl) {
    if (!modalEl) return;

    var mid = modalEl.id || '';
    deactivateModal(modalEl);

    var stillOpen = qsa('.modal.modal--is-active, .modal[aria-hidden="false"]').length > 0;
    if (!stillOpen) {
      document.documentElement.classList.remove('modal-open');
      try { document.body.classList.remove('modal-open'); } catch (_) {}
    }

    if (mid && STATE.modal.activeId === mid) STATE.modal.activeId = '';

    dispatchModalLifecycle(mid, false, modalEl);

    try {
      var pf = STATE.modal.prevFocus;
      STATE.modal.prevFocus = null;
      if (pf && typeof pf.focus === 'function') pf.focus();
    } catch (_) {}
  }

  // -------------------------------------------------
  // Quick shop modal discovery (supports both Impulse + Clerk wrappers)
  // -------------------------------------------------
  function findQuickShopModal(productId, triggerEl) {
    var pid = String(productId || '').replace(/[^\d]/g, '');
    if (!pid && triggerEl) {
      var fromTrigger = triggerEl.getAttribute && triggerEl.getAttribute('aria-controls');
      if (fromTrigger) {
        return document.getElementById(fromTrigger) || null;
      }
    }
    if (!pid) return null;

    var byAria = triggerEl && triggerEl.getAttribute && triggerEl.getAttribute('aria-controls');
    if (byAria) {
      var m0 = document.getElementById(byAria);
      if (m0) return m0;
    }

    var m1 = document.getElementById('QuickShopModal-' + pid);
    if (m1) return m1;

    var m2 = document.getElementById('quick-modal-' + pid);
    if (m2) return m2;

    var m3 = document.querySelector('.modal.modal--quick-shop[data-product-id="' + cssEscape(pid) + '"]');
    if (m3) return m3;

    return null;
  }

  function getQuickShopHolder(modalEl, productId, handle) {
    if (!modalEl) return null;
    var pid = String(productId || '').replace(/[^\d]/g, '');
    handle = normalizeHandle(handle);

    var holder =
      (handle && modalEl.querySelector && modalEl.querySelector('#QuickShopHolder-' + cssEscape(handle))) ||
      (pid && modalEl.querySelector && modalEl.querySelector('#QuickShopHolder-' + cssEscape(pid))) ||
      (modalEl.querySelector && modalEl.querySelector('[id^="QuickShopHolder-"]'));

    return holder || null;
  }

  function normalizeQuickShopModalId(modalEl, productId, triggerEl) {
    if (!modalEl) return null;
    var pid = String(productId || '').replace(/[^\d]/g, '');
    if (!pid) return modalEl;

    var expectedId = 'QuickShopModal-' + pid;
    var legacyId = 'quick-modal-' + pid;
    var currentId = String(modalEl.id || '');

    if (currentId === expectedId) return modalEl;
    if (currentId !== legacyId) return modalEl;

    // Avoid collisions if native modal already exists
    var existingNative = document.getElementById(expectedId);
    if (existingNative && existingNative !== modalEl) return existingNative;

    try {
      modalEl.id = expectedId;
      modalEl.setAttribute('data-rittencom-legacy-id', legacyId);
      modalEl.setAttribute('data-rittencom-origin', 'clerk');

      // Keep trigger wiring coherent for subsequent opens
      var selector = '[aria-controls="' + cssEscape(legacyId) + '"]';
      var linked = document.querySelectorAll(selector);
      for (var i = 0; i < linked.length; i++) {
        try { linked[i].setAttribute('aria-controls', expectedId); } catch (_) {}
      }
      if (triggerEl && triggerEl.setAttribute) {
        try { triggerEl.setAttribute('aria-controls', expectedId); } catch (_) {}
      }

      flog('normalizeQuickShopModalId:renamed', { from: legacyId, to: expectedId });
    } catch (_) {}

    return modalEl;
  }

  function normalizeQuickShopHolderId(modalEl, productId, handle) {
    if (!modalEl) return null;
    var pid = String(productId || '').replace(/[^\d]/g, '');
    handle = normalizeHandle(handle);
    if (!pid || !handle) return getQuickShopHolder(modalEl, productId, handle);

    var holder = getQuickShopHolder(modalEl, productId, handle);
    if (!holder || !holder.id) return holder || null;

    var expectedHandleId = 'QuickShopHolder-' + handle;
    var pidId = 'QuickShopHolder-' + pid;
    if (holder.id === pidId && holder.id !== expectedHandleId) {
      try {
        holder.id = expectedHandleId;
        flog('normalizeQuickShopHolderId:renamed', { from: pidId, to: expectedHandleId, modalId: modalEl.id || null });
      } catch (_) {}
    }

    return holder;
  }

  function extractHandleFromModal(productId, triggerEl) {
    var m = findQuickShopModal(productId, triggerEl);
    if (!m || !m.querySelector) return '';
    var holder = m.querySelector('[id^="QuickShopHolder-"]');
    if (!holder || !holder.id) return '';
    return normalizeHandle(holder.id.replace(/^QuickShopHolder-/, ''));
  }

  function isClerkShellModal(modalEl, productId) {
    if (!modalEl) return false;
    if (modalEl.getAttribute && modalEl.getAttribute('data-rittencom-origin') === 'clerk') return true;
    if (modalEl.getAttribute && modalEl.getAttribute('data-rittencom-legacy-id')) return true;
    var pid = String(productId || '').replace(/[^\d]/g, '');
    var mid = String(modalEl.id || '');
    if (pid && mid === ('quick-modal-' + pid)) return true;

    var holder = modalEl.querySelector && modalEl.querySelector('[id^="QuickShopHolder-"]');
    var hid = holder && holder.id ? String(holder.id) : '';
    if (pid && hid === ('QuickShopHolder-' + pid)) return true;

    return false;
  }

  function hasNativeQuickShopBindings(scope) {
    if (!scope || !scope.querySelector) return false;
    var hasPlaceholder = !!scope.querySelector('.placeholder-content');
    var hasLoadedBlocks = !!scope.querySelector('.product-form-holder--loaded');
    var hasNativeModalForm = !!scope.querySelector('form[id^="AddToCartForm-"][id*="-modal"]');
    var hasNativeVariantSelect = !!scope.querySelector('form [data-product-select]');
    var hasNativeQty = !!scope.querySelector('.product__quantity .js-qty__num');
    var hasModalProductSection = !!scope.querySelector('.product-section.is-modal[data-modal="true"]');

    // Native quick shop must have real form bindings, not just Clerk placeholder/product shell.
    return (
      hasModalProductSection &&
      !hasPlaceholder &&
      (
        hasLoadedBlocks ||
        hasNativeModalForm ||
        (hasNativeVariantSelect && hasNativeQty)
      )
    );
  }

  function isClerkHydrated(productId, handle, triggerEl) {
    var m = findQuickShopModal(productId, triggerEl);
    if (!m) return false;
    var h = getQuickShopHolder(m, productId, handle);
    if (!h) return false;
    var hasSection = !!h.querySelector('.product-section.is-modal, .product-section[data-product-handle], [data-section-type="product"], [data-section-id]');
    if (!hasSection) return false;

    // Clerk quick-modal shells often include a lightweight product-section that is NOT
    // native-initialized. Require stronger markers before treating it as hydrated.
    if (isClerkShellModal(m, productId)) {
      return hasNativeQuickShopBindings(h);
    }

    return true;
  }

  // -------------------------------------------------
  // Theme/app reprocessing nudges
  // -------------------------------------------------
  function dispatchSectionLoadEvents(scope) {
    if (!scope) return;

    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-section-id]') : [];
    for (var i = 0; i < sections.length; i++) {
      var el = sections[i];
      var sid = el.getAttribute('data-section-id') || '';

      // Fire on the element
      try {
        var ev1 = new CustomEvent('shopify:section:load', { bubbles: true });
        ev1.detail = { sectionId: sid };
        el.dispatchEvent(ev1);
      } catch (_) {}

      // And on document (some listeners attach there)
      try {
        var ev2 = new CustomEvent('shopify:section:load', { bubbles: true });
        ev2.detail = { sectionId: sid };
        document.dispatchEvent(ev2);
      } catch (_) {}
    }
  }

  function tryInitImpulseSections(scope) {
    if (!scope) return false;

    // Best-effort, no assumptions
    try {
      if (window.theme && theme.sections) {
        if (typeof theme.sections.loadSections === 'function') { theme.sections.loadSections(scope); return true; }
        if (typeof theme.sections.load === 'function') { theme.sections.load(scope); return true; }
        if (typeof theme.sections.init === 'function') { theme.sections.init(scope); return true; }
      }
    } catch (_) {}

    dispatchSectionLoadEvents(scope);
    return false;
  }

  function nudgeApps(scope, productId) {
    var pid = String(productId || '');
    try { document.dispatchEvent(new CustomEvent('quickshop:open', { detail: { productId: pid, scope: scope || null } })); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('quickshop:loaded', { detail: { productId: pid, scope: scope || null } })); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('vp:refresh', { detail: { productId: pid, scope: scope || null } })); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: null }, productId: pid, scope: scope || null } })); } catch (_) {}
  }

  function preloadIntoKnownModal(productId, handle, triggerEl) {
    productId = String(productId || '').replace(/[^\d]/g, '');
    handle = normalizeHandle(handle);

    if (!productId || !handle) return Promise.resolve(false);

    var modalEl = normalizeQuickShopModalId(findQuickShopModal(productId, triggerEl), productId, triggerEl);
    var holder = normalizeQuickShopHolderId(modalEl, productId, handle);
    if (!modalEl || !holder) return Promise.resolve(false);

    var url = ((window.theme && theme.routes && theme.routes.home) ? theme.routes.home : '') + '/products/' + handle + '?view=modal';
    url = url.replace('//', '/');

    flog('preloadIntoKnownModal:start', { productId: productId, handle: handle, modalId: modalEl.id || null });

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;

        var selector = '.product-section[data-product-handle="' + cssEscape(handle) + '"]';
        var div = html.querySelector(selector) || html.querySelector('.product-section');
        if (!div) return false;

        holder.innerHTML = '';
        holder.append(div);

        try {
          if (window.theme && typeof theme.Modals === 'function') {
            new theme.Modals('QuickShopModal-' + productId, 'quick-modal-' + productId);
          }
        } catch (_) {}

        try {
          if (window.theme && theme.sections && typeof theme.sections.register === 'function' && theme.Product) {
            theme.sections.register('product', theme.Product, holder);
          }
        } catch (_) {}

        try { if (window.theme && theme.collapsibles && typeof theme.collapsibles.init === 'function') theme.collapsibles.init(); } catch (_) {}
        try { if (window.theme && typeof theme.videoModal === 'function') theme.videoModal(); } catch (_) {}
        try { tryInitImpulseSections(holder); } catch (_) {}
        try { dispatchSectionLoadEvents(holder); } catch (_) {}
        try { nudgeApps(holder, productId); } catch (_) {}

        if (triggerEl && triggerEl.classList) {
          triggerEl.classList.remove('quick-product__btn--not-ready');
        }

        return isClerkHydrated(productId, handle, triggerEl);
      })
      .catch(function (e) {
        flog('preloadIntoKnownModal:failed', { productId: productId, handle: handle, error: String((e && e.message) || e) });
        return false;
      });
  }

  // -------------------------------------------------
  // The IMPORTANT part: use native theme.preloadProductModal
  // to inject the real product/section HTML into the CLERK modal,
  // then open that modal.
  // -------------------------------------------------
  function preloadIntoClerkModalOnce(productId, handle, triggerEl) {
    productId = String(productId || '').replace(/[^\d]/g, '');
    handle = normalizeHandle(handle);

    if (!productId || !handle) return Promise.resolve(false);

    // If already hydrated, we’re good
    if (isClerkHydrated(productId, handle, triggerEl)) {
      flog('preloadIntoClerkModalOnce:already-hydrated', { productId: productId, handle: handle });
      return Promise.resolve(true);
    }

    STATE.qs.preloadByPid = STATE.qs.preloadByPid || {};
    if (STATE.qs.preloadByPid[productId]) return STATE.qs.preloadByPid[productId];

    if (!window.theme || typeof theme.preloadProductModal !== 'function') {
      return preloadIntoKnownModal(productId, handle, triggerEl);
    }

    var modalEl = normalizeQuickShopModalId(findQuickShopModal(productId, triggerEl), productId, triggerEl);
    var fastTimeout = isClerkShellModal(modalEl, productId) ? 1800 : 7000;

    // Clerk-origin quick modals are frequently lightweight shells that never pass through
    // Impulse's full native preload path reliably. Use explicit fetch+inject path.
    if (isClerkShellModal(modalEl, productId)) {
      flog('preloadIntoClerkModalOnce:force-known-modal', { productId: productId, handle: handle });
      return preloadIntoKnownModal(productId, handle, triggerEl);
    }

    var p = Promise.resolve()
      .then(function () {
        // This is the Impulse native quick shop renderer.
        // On your setup, it renders into QuickShopHolder-<pid> INSIDE #quick-modal-<pid>.
        normalizeQuickShopHolderId(modalEl, productId, handle);
        theme.preloadProductModal(handle, productId, triggerEl || null);
      })
      .then(function () {
        return waitFor(function () { return isClerkHydrated(productId, handle, triggerEl); }, { timeout: fastTimeout, label: 'preloadIntoClerkModalOnce' });
      })
      .then(function () { return true; })
      .catch(function (e) {
        flog('preloadIntoClerkModalOnce:native-failed', { productId: productId, handle: handle, error: String((e && e.message) || e) });
        return preloadIntoKnownModal(productId, handle, triggerEl);
      });

    STATE.qs.preloadByPid[productId] = p;
    return p;
  }

  function openNativeQuickShop(productId, handle, triggerEl) {
    productId = String(productId || '').replace(/[^\d]/g, '');
    handle = normalizeHandle(handle);

    if (!productId) return Promise.resolve(false);
    if (!handle) handle = extractHandleFromModal(productId, triggerEl);
    if (!handle) return Promise.resolve(false);
    if (isMutexLocked()) return Promise.resolve(true);
    lockMutex(1200);

    if (shouldThrottleOpen(productId)) return Promise.resolve(true);

    var t0 = Date.now();
    flog('openNativeQuickShop:start', { productId: productId, handle: handle });

    var modalEl = normalizeQuickShopModalId(findQuickShopModal(productId, triggerEl), productId, triggerEl);
    if (!modalEl) {
      // If for some reason Clerk hasn't created it, fallback to PDP.
      flog('openNativeQuickShop:no-modal', { productId: productId, handle: handle });
      window.location.href = '/products/' + handle;
      return Promise.resolve(true);
    }

    // Always bind close behavior
    bindModalCloseOnce(modalEl);

    closeAllModalsExcept('');
    closeCartDrawerIfOpen();

    return preloadIntoClerkModalOnce(productId, handle, triggerEl)
      .then(function (preloaded) {
        portalize(modalEl);

        // Open visually, always.
        var ok = openModal(modalEl, triggerEl);

        // Re-process the injected HTML so sections/apps (volume pricing etc) can bind.
        var holder = getQuickShopHolder(modalEl, productId, handle) || modalEl;

        // Do a couple passes because Impulse + apps can attach late.
        setTimeout(function () {
          tryInitImpulseSections(holder);
          dispatchSectionLoadEvents(holder);
          nudgeApps(holder, productId);
        }, 0);

        setTimeout(function () {
          tryInitImpulseSections(holder);
          dispatchSectionLoadEvents(holder);
          nudgeApps(holder, productId);
        }, 250);

        setTimeout(function () {
          nudgeApps(holder, productId);
        }, 900);

        flog('openNativeQuickShop:opened', {
          ms: Date.now() - t0,
          mid: modalEl.id,
          ok: !!ok,
          preloaded: !!preloaded
        });

        return true;
      })
      .catch(function (err) {
        flog('openNativeQuickShop:failed', { productId: productId, handle: handle, error: String((err && err.message) || err) });
        window.location.href = '/products/' + handle;
        return true;
      });
  }

  function isLikelyClerkContext(el) {
    if (!el || !el.closest) return false;
    return !!(
      el.closest('.clerk') ||
      el.closest('.clerk-swiper-wrapper') ||
      el.closest('.clerk-slider-wrapper') ||
      el.closest('.clerk-slide') ||
      el.closest('[data-clerk-product-id]')
    );
  }

  function getClerkQuickTrigger(target) {
    if (!target || !target.closest) return null;

    var btn = target.closest('.js-clerk-qv');
    if (btn) return btn;

    var maybeNativeQuickBtn = target.closest('button[class*="js-modal-open-quick-modal-"]');
    if (!maybeNativeQuickBtn) return null;

    if (isLikelyClerkContext(maybeNativeQuickBtn)) return maybeNativeQuickBtn;
    return null;
  }

  // -------------------------------------------------
  // GLOBAL interceptor (Clerk QV button): open native-rendered quick shop
  // -------------------------------------------------
  function initQuickShopGlobalInterceptor() {
    if (STATE.qsInterceptor.inited) return;
    STATE.qsInterceptor.inited = true;

    function armSuppressClick(pid) {
      STATE.modal.suppressClickUntil = Date.now() + 800;
      STATE.modal.suppressClickPid = String(pid || '');
    }

    // 1) pointerdown: ONLY arm suppression (do not open)
    function onPointerDown(e) {
      if (!e || !e.target || !e.target.closest) return;
      var t = e.target;

      var qvBtn = getClerkQuickTrigger(t);
      if (!qvBtn) return;

      var pid = getProductIdFromAny(qvBtn);
      if (!pid) return;

      armSuppressClick(pid);
    }

    // 2) click capture: OWN the click, open native-rendered quick shop
    function onClickCapture(e) {
      if (!e || !e.target || !e.target.closest) return;
      var t = e.target;

      // Never hijack clicks inside any modal (keeps close button etc working)
      if (t.closest('.modal.modal--is-active, .modal[aria-hidden="false"]')) return;

      var qvBtn = getClerkQuickTrigger(t);
      if (!qvBtn) return;

      var pid = getProductIdFromAny(qvBtn);
      var handle = extractHandleNearQuickButton(qvBtn);

      if (!pid || !handle) return;

      if (!markEventHandled(e, 'clerk-click-owned')) return;
      stopAll(e);

      openNativeQuickShop(pid, handle, qvBtn);
    }

    // 3) swallow late click handlers briefly (ONLY on the button)
    function onClickSwallow(e) {
      if (!e || !e.target || !e.target.closest) return;
      var now = Date.now();
      if (now > safeNumber(STATE.modal.suppressClickUntil, 0)) return;

      var t = e.target;
      var qvBtn = getClerkQuickTrigger(t);
      if (!qvBtn) return;

      var pid = getProductIdFromAny(qvBtn);
      if (!pid) return;

      if (String(pid) !== String(STATE.modal.suppressClickPid || '')) return;

      stopAll(e);
    }

    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('mousedown', onPointerDown, true);

    document.addEventListener('click', onClickCapture, true);
    document.addEventListener('click', onClickSwallow, false);

  }

  // -------------------------------------------------
  // CartDrawer wiring (kept)
  // -------------------------------------------------
  function initCartDrawerQuickShopDummyWiring() {
    if (STATE.qs.inited) return;
    STATE.qs.inited = true;

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var inDrawer = t.closest('#CartDrawer');
      if (!inDrawer) return;

      if (t.closest('.js-modal-close, .modal__close, [data-close-modal]')) return;

      var trigger = t.closest('button, a');
      if (!trigger) return;

      var pid = getProductIdFromTriggerClass(trigger);
      if (!pid) return;

      if (!markEventHandled(e, 'drawer-native')) return;
      stopAll(e);

      var handle = extractHandleNearQuickButton(trigger);
      openNativeQuickShop(pid, handle, trigger);
    }, true);
  }

  // -------------------------------------------------
  // Keep these initializers
  // -------------------------------------------------
  function initClerkQuickView() {
    if (STATE.clerkQuickView.inited) return;
    STATE.clerkQuickView.inited = true;
  }

  function initClerkCartRecsQuickShopBridge() {
    if (STATE.clerkRecsBridge.inited) return;
    STATE.clerkRecsBridge.inited = true;
  }

  // -------------------------------------------------
  // CORE FEATURE (1): Untaxed subtotal + free shipping bar
  // -------------------------------------------------
  function initUntaxedSubtotalAndFreeShipping() {
    if (STATE.subtotalObs.inited) return;
    STATE.subtotalObs.inited = true;

    var target = qs('[data-subtotal]');
    if (!target) return;

    var observer = new MutationObserver(updateSubtotal);
    observer.observe(target, {
      characterData: false,
      attributes: false,
      childList: true,
      subtree: false
    });
    STATE.subtotalObs.observer = observer;

    updateSubtotal();

    function updateSubtotal() {
      var cartSubtotal = qs('[data-cart-subtotal]');
      if (!cartSubtotal) return;

      var subtotal = safeNumber(cartSubtotal.dataset.cartSubtotal, 0);
      var out = qs('[data-untaxed-subtotal]');

      if (out && window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        out.innerText = theme.Currency.formatMoney(subtotal * 0.8, theme.settings.moneyFormat);
      }

      updateFreeShippingBar(subtotal);
    }

    function updateFreeShippingBar(subtotal) {
      var freeShippingBar = qs('.free-shipping-bar');
      if (!freeShippingBar) return;

      var freeShippingAmount = safeNumber(freeShippingBar.dataset.freeShippingAmount, 0);
      if (!freeShippingAmount) return;

      var cart_drawer = document.getElementById('CartDrawer');
      var isEmpty = cart_drawer ? cart_drawer.classList.contains('is-empty') : false;

      var progress = subtotal / freeShippingAmount;
      progress = Math.min(1, Math.max(0, safeNumber(progress, 0)));

      var difference = Math.max(0, freeShippingAmount - subtotal);
      var differenceFormatted =
        window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat
          ? theme.Currency.formatMoney(difference, theme.settings.moneyFormat)
          : String(difference);

      if (isEmpty) {
        freeShippingBar.classList.add('free-shipping-bar--no-cart');
      } else {
        freeShippingBar.classList.remove('free-shipping-bar--no-cart');
      }

      freeShippingBar.style.setProperty('--free-shipping-progress', progress);
      freeShippingBar.dataset.freeShippingProgress = progress;

      var msgNo = freeShippingBar.querySelector('.free-shipping-bar__message--no');
      if (progress < 1 && msgNo) {
        msgNo.innerText = 'Du er ' + differenceFormatted + ' fra gratis fragt';
        freeShippingBar.style.setProperty('--free-shipping-bar-color', '#F47D02');
      } else {
        freeShippingBar.style.setProperty('--free-shipping-bar-color', '#00800A');
      }
    }
  }

  // -------------------------------------------------
  // CORE FEATURE (4): Cart recommendations bar (desktop only)
  // -------------------------------------------------
  function initCartRecsBar() {
    if (STATE.cartRecs.inited) return;
    STATE.cartRecs.inited = true;

    var drawer = document.getElementById('CartDrawer');
    var bar = qs('.cart-recs-bar');
    if (!drawer || !bar) return;

    var DESKTOP_MQ = window.matchMedia('(min-width: 1025px)');
    var html = document.documentElement;

    var drawerAttrObserver = null;
    var drawerSizeObserver = null;

    var stopPropOnBarPointer = null;
    var stopPropOnBarClick = null;

    function isDrawerOpen() {
      return (
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('drawer--is-open') ||
        drawer.getAttribute('aria-hidden') === 'false'
      );
    }

    function setDrawerWidthVar() {
      var rect = drawer.getBoundingClientRect();
      var w = rect && rect.width ? rect.width : (drawer.offsetWidth || 420);
      html.style.setProperty('--cart-drawer-width', Math.round(w) + 'px');
    }

    function ensureBarIsViewportFixed() {
      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }
    }

    function enableStopPropagation() {
      if (stopPropOnBarPointer) return;

      stopPropOnBarPointer = function (e) { e.stopPropagation(); };
      stopPropOnBarClick = function (e) { e.stopPropagation(); };

      bar.addEventListener('pointerdown', stopPropOnBarPointer, false);
      bar.addEventListener('mousedown', stopPropOnBarPointer, false);
      bar.addEventListener('touchstart', stopPropOnBarPointer, { passive: true });
      bar.addEventListener('click', stopPropOnBarClick, false);
    }

    function disableStopPropagation() {
      if (!stopPropOnBarPointer) return;

      bar.removeEventListener('pointerdown', stopPropOnBarPointer, false);
      bar.removeEventListener('mousedown', stopPropOnBarPointer, false);
      bar.removeEventListener('touchstart', stopPropOnBarPointer);
      bar.removeEventListener('click', stopPropOnBarClick, false);

      stopPropOnBarPointer = null;
      stopPropOnBarClick = null;
    }

    function observeDrawerAttributes() {
      if (drawerAttrObserver) return;

      drawerAttrObserver = new MutationObserver(function () {
        syncState();
      });

      drawerAttrObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    function observeDrawerSize() {
      if (drawerSizeObserver || !window.ResizeObserver) return;

      drawerSizeObserver = new ResizeObserver(function () {
        if (DESKTOP_MQ.matches && isDrawerOpen()) {
          setDrawerWidthVar();
        }
      });

      drawerSizeObserver.observe(drawer);
    }

    function syncState() {
      if (!DESKTOP_MQ.matches) {
        html.classList.remove('cart-drawer-open');
        html.style.setProperty('--cart-drawer-width', '420px');
        bar.setAttribute('hidden', 'hidden');
        disableStopPropagation();
        return;
      }

      bar.removeAttribute('hidden');
      ensureBarIsViewportFixed();

      var open = isDrawerOpen();
      html.classList.toggle('cart-drawer-open', !!open);

      if (open) {
        setDrawerWidthVar();
        enableStopPropagation();
      } else {
        disableStopPropagation();
      }
    }

    function onResize() {
      if (!DESKTOP_MQ.matches) return;
      if (isDrawerOpen()) setDrawerWidthVar();
    }

    function onMediaChange() {
      syncState();
    }

    ensureBarIsViewportFixed();
    observeDrawerAttributes();
    observeDrawerSize();
    syncState();

    window.addEventListener('resize', onResize);

    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener('change', onMediaChange);
    } else if (DESKTOP_MQ.addListener) {
      DESKTOP_MQ.addListener(onMediaChange);
    }
  }

  // -------------------------------------------------
  // CORE FEATURE (2): Collection description excerpts
  // -------------------------------------------------
  function initCollectionExcerpts() {
    if (!document.body.classList.contains('template-collection')) return;

    var descriptions = qsa('.collection__description');
    if (!descriptions.length) return;

    descriptions.forEach(function (desc) {
      var next = desc.nextElementSibling;
      if (next && next.classList && next.classList.contains('js-show-more')) return;

      var showMoreLink = document.createElement('a');
      showMoreLink.innerHTML = "Læs mere <i class='arrow down'></i>";
      showMoreLink.href = '#';
      showMoreLink.classList.add('js-show-more');
      showMoreLink.setAttribute('role', 'button');

      desc.after(showMoreLink);

      showMoreLink.addEventListener('click', function (event) {
        event.preventDefault();

        var excerptTarget = showMoreLink.previousElementSibling;
        if (!excerptTarget) return;

        if (!excerptTarget.classList.contains('excerpt-visible')) {
          showMoreLink.innerHTML = "Læs mindre <i class='arrow up'></i>";
          excerptTarget.classList.add('excerpt-visible');
        } else {
          showMoreLink.innerHTML = "Læs mere <i class='arrow down'></i>";
          excerptTarget.classList.remove('excerpt-visible');
        }
      });
    });
  }

  // -------------------------------------------------
  // Theme section registry hook (kept as-is)
  // -------------------------------------------------
  rittencom.extends = rittencom.extends || {};
  rittencom.extends.Product = rittencom.extends.Product || {
    init: function () { /* reserved hooks */ }
  };

  // -------------------------------------------------
  // CORE FEATURE (3): Register Impulse theme sections
  // -------------------------------------------------
  function registerImpulseSections() {
    if (STATE.sections.registered) return;
    if (!(window.theme && theme.sections && typeof theme.sections.register === 'function')) return;

    // On normal PDPs, Impulse has already initialized the product controller.
    // Registering it again duplicates .js-qty button handlers.
    if (document.querySelector('.product__quantity .js-qty__num')) {
      flog('registerImpulseSections:skip-existing-pdp-product-section');
      return;
    }

    var productController = (theme && theme.Product) ? theme.Product : rittencom.extends.Product.init;

    try {
      theme.sections.register('product', productController);
      STATE.sections.registered = true;
    } catch (e) {
      console.warn('[rittencom] theme.sections.register(product) failed', e);
    }
  }

  // -------------------------------------------------
  // Main init
  // -------------------------------------------------
  function init() {
    if (STATE.main.inited) return;
    STATE.main.inited = true;

    initQuickShopGlobalInterceptor();
    initCartDrawerQuickShopDummyWiring();
    initClerkQuickView();
    initClerkCartRecsQuickShopBridge();

    // -------------------------------------------------
    // CORE FEATURES (must remain present + called)
    // -------------------------------------------------
    initUntaxedSubtotalAndFreeShipping(); // (1) CORE
    initCartRecsBar();                   // (4) CORE
    initCollectionExcerpts();            // (2) CORE
    registerImpulseSections();           // (3) CORE

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
  });

})();


/* -------------------------------------------------
   HOTFIX: Clerk Quick Shop -> force native Impulse open
   Paste at very bottom of rittencom.js
------------------------------------------------- */
(function () {
  'use strict';

  if (window.__RITTENCOM_QS_NATIVE_BRIDGE__) return;

  function closestMatch(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getFacts(btn) {
    var pid = btn && (btn.getAttribute('data-product-id') || btn.dataset.productId);
    var handle = btn && (btn.getAttribute('data-product-handle') || btn.dataset.productHandle);
    var mid = pid ? ('quick-modal-' + pid) : (btn && btn.getAttribute('aria-controls'));
    return { pid: pid, handle: handle, mid: mid };
  }

  function moveModalToBody(mid) {
    if (!mid) return null;
    var modal = document.getElementById(mid);
    if (!modal) return null;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function openModalFallback(modal) {
    if (!modal) return false;

    // Impulse tends to toggle these (varies by version)
    modal.classList.add('modal--is-active');
    modal.classList.add('is-active');
    document.documentElement.classList.add('modal-open');
    document.body.classList.add('modal-open');

    // Ensure close works even if theme didn't bind
    var closeBtn = modal.querySelector('.js-modal-close, .modal__close');
    if (closeBtn && !closeBtn.__rittencomBoundClose) {
      closeBtn.__rittencomBoundClose = true;
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.remove('modal--is-active');
        modal.classList.remove('is-active');
        document.documentElement.classList.remove('modal-open');
        document.body.classList.remove('modal-open');
      });
    }
    return true;
  }

  function dispatchReinit(modal) {
    try {
      // Let your VP script re-init if it listens for this
      document.dispatchEvent(new CustomEvent('vp:refresh', { detail: { scope: modal } }));
    } catch (e) {}

    // Also fire Shopify/Theme style section events if we can infer section id
    try {
      var productSection = modal && modal.querySelector('.product-section[data-section-id]');
      var sectionId = productSection && productSection.getAttribute('data-section-id');
      if (sectionId) {
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sectionId } }));
      }
    } catch (e2) {}
  }

  function tryOpenNative(btn, facts) {
    // Probe common Impulse theme APIs (names vary)
    var t = window.theme || {};
    var opened = false;

    // 1) QuickShop API variants
    var candidates = [
      t.QuickShop,
      t.quickShop,
      t.Quickshop,
      t.quickshop
    ].filter(Boolean);

    for (var i = 0; i < candidates.length && !opened; i++) {
      var q = candidates[i];
      // common method names
      var fns = ['open', 'load', 'openQuickShop', 'openModal'];
      for (var j = 0; j < fns.length && !opened; j++) {
        var fn = q && q[fns[j]];
        if (typeof fn === 'function') {
          try {
            // Try different signatures safely
            // (handle, id) or ({handle,id}) or (id) etc.
            fn.call(q, facts.handle, facts.pid);
            opened = true;
          } catch (e1) {
            try { fn.call(q, { handle: facts.handle, id: facts.pid, productId: facts.pid, modalId: facts.mid }); opened = true; }
            catch (e2) {}
          }
        }
      }
    }

    // 2) Modals API variants
    if (!opened) {
      var m = t.Modals || t.modals || t.modal;
      if (m) {
        var openFn = m.open || m.openModal || m.show;
        if (typeof openFn === 'function' && facts.mid) {
          try { openFn.call(m, facts.mid); opened = true; } catch (e3) {}
        }
      }
    }

    // 3) Last resort: synthetically click the button again without our interference
    // (Some themes bind directly to the button's unique class)
    if (!opened) {
      try {
        // Ensure aria-controls present
        if (facts.mid && !btn.getAttribute('aria-controls')) btn.setAttribute('aria-controls', facts.mid);
        // Let the theme's own click handlers run by re-dispatching a fresh event
        btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        opened = true; // optimistic
      } catch (e4) {}
    }

    return opened;
  }

  // Capture-phase: run before Clerk / other scripts
  document.addEventListener('click', function (e) {
    var btn = closestMatch(e.target, 'button.js-clerk-qv');
    if (!btn) return;

    var facts = getFacts(btn);
    if (!facts.pid || !facts.mid) return;

    // Always ensure modal is in <body> (Impulse scripts often assume this)
    var modal = moveModalToBody(facts.mid);

    // Try native theme open FIRST
    var okNative = tryOpenNative(btn, facts);

    // If native didn’t actually activate anything, fallback open
    // (we detect by class after a tick)
    setTimeout(function () {
      var m2 = document.getElementById(facts.mid);
      var isActive = m2 && (m2.classList.contains('modal--is-active') || m2.classList.contains('is-active'));
      if (!isActive) {
        openModalFallback(m2);
      }
      dispatchReinit(m2);
    }, 0);
  }, true);
})();


/* BEGIN RITTENCOM RECOMMENDATION ADDONS 2026-09-08 */
/* Append AFTER all existing code in rittencom.js. Do not replace that file.
 * Cares complementary recommendations, v2026-09-08.
 * No selections: Impulse handles the original product form as before.
 * Selections: one multipart cart request, preserving the main form's fields.
 */
(function () {
  'use strict';
  if (window.__rittencomRecommendationAddons) return;
  window.__rittencomRecommendationAddons = true;

  const ROOT = '#Recommendations-template--30442354770252__main';
  const states = new WeakMap();
  const products = new Map();
  let busy = false;
  let needsReview = false;
  const route = (path) => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path;

  function getForm(root) {
    return document.getElementById('AddToCartForm-' + root.dataset.sectionId + '-' + root.dataset.productId);
  }

  function resize(root) {
    requestAnimationFrame(function () {
      // Impulse's existing Slideshow wraps its Flickity instance.
      if (root.flickity && typeof root.flickity.resize === 'function') root.flickity.resize();
    });
  }

  function message(root, text, review) {
    let status = root.querySelector('.rc-addon-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'rc-addon-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      root.append(status);
    }
    status.replaceChildren(document.createTextNode(text));
    status.hidden = !text;
    if (review) {
      const link = document.createElement('a');
      link.href = route('cart');
      link.textContent = 'Se kurven';
      status.append(document.createTextNode(' '), link);
    }
    resize(root);
  }

  function controls(root) {
    const form = getForm(root);
    return [...root.querySelectorAll('.rc-addon-check, .rc-addon-add'),
      ...(form ? [...form.elements].filter(el => el.type === 'submit') : [])];
  }

  async function productFor(card) {
    const handle = card.dataset.productHandle;
    if (!handle) throw new Error('Missing product handle');
    if (!products.has(handle)) {
      products.set(handle, fetch(route('products/' + encodeURIComponent(handle) + '.js'), {
        credentials: 'same-origin', headers: { Accept: 'application/json' },
        signal: AbortSignal.timeout(12000)
      }).then(response => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).catch(error => { products.delete(handle); throw error; }));
    }
    const product = await products.get(handle);
    if (String(product.id) !== card.dataset.productId) throw new Error('Product identity mismatch');
    return product;
  }

  function readMainItem(form) {
    const original = new FormData(form); // Includes external quantity inputs linked by form="...".
    const id = original.get('id');
    const qty = Number(original.get('quantity') || 1);
    if (!/^\d+$/.test(String(id)) || !Number.isSafeInteger(qty) || qty < 1) {
      throw new Error('Vælg en variant og et gyldigt antal.');
    }
    if ([...original.keys()].some(key => key.startsWith('items['))) {
      throw new Error('Dette produkt kræver sin egen tilkøbsfunktion. Fjern markeringerne og prøv igen.');
    }
    const body = new FormData();
    body.append('items[0][id]', id);
    body.append('items[0][quantity]', String(qty));
    for (const [key, value] of original) {
      const property = /^properties\[(.*)\]$/.exec(key);
      if (property) body.append('items[0][properties][' + property[1] + ']', value);
      else if (key === 'selling_plan' && value) body.append('items[0][selling_plan]', value);
      else if (!['id', 'quantity', 'selling_plan', 'form_type', 'utf8', 'product-id', 'section-id'].includes(key)) {
        body.append(key, value);
      }
    }
    return body;
  }

  async function add(root, form, button, selected, includeMain) {
    if (busy || needsReview) return;
    if (form && form.querySelector('.btn--loading')) return;
    let body;
    try {
      body = includeMain ? readMainItem(form) : new FormData();
      selected.forEach((state, i) => {
        const index = i + (includeMain ? 1 : 0);
        body.append('items[' + index + '][id]', String(state.variantId));
        body.append('items[' + index + '][quantity]', '1');
      });
    } catch (error) { message(root, error.message); return; }

    busy = true;
    const previous = controls(root).map(el => [el, el.disabled]);
    previous.forEach(([el]) => { el.disabled = true; });
    button.classList.add('btn--loading');
    button.setAttribute('aria-busy', 'true');
    message(root, 'Lægger i kurven…');
    let added;
    try {
      const response = await fetch(route('cart/add.js'), {
        method: 'POST', credentials: 'same-origin', body,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        signal: AbortSignal.timeout(20000)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400 || !Array.isArray(result.items)) {
        const description = typeof result.description === 'string' ? result.description : '';
        throw new Error(description || 'Varerne kunne ikke bekræftes tilføjet.');
      }
      added = result;
    } catch (error) {
      // An interrupted/error response can leave an uncertain cart state. Never retry the POST.
      needsReview = true;
      const explanation = error.name === 'TimeoutError' || error.name === 'TypeError'
        ? 'Forbindelsen blev afbrudt.' : error.message;
      message(root, explanation + ' Kontrollér kurven og genindlæs siden, før du prøver igen.', true);
    } finally {
      busy = false;
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-busy');
      if (!needsReview) {
        previous.forEach(([el, disabled]) => { el.disabled = disabled; });
        root.querySelectorAll('.grid-product[data-product-id]').forEach(card => {
          const state = states.get(card);
          if (state && state.variantId) state.check.disabled = state.button.disabled = false;
        });
      }
    }
    if (!added) return;

    selected.forEach(state => { state.check.checked = false; });
    message(root, includeMain ? 'Produkt og valgte tilkøb er lagt i kurven.' : 'Tilkøbet er lagt i kurven.');
    // One existing Impulse event rebuilds and opens the existing drawer.
    // Do not instantiate another theme.CartDrawer or duplicate the main theme's submit handler.
    const target = includeMain ? form : root;
    target.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true, detail: { product: added.items[0], items: added.items, addToCartBtn: button }
    }));
    if (!document.getElementById('CartDrawer') || (window.theme && theme.settings && theme.settings.cartType === 'page')) {
      window.location.assign(route('cart'));
    }
  }

  async function enhance(card, root) {
    if (states.has(card)) return;
    const row = card.querySelector('.grid__item-image-wrapper');
    const link = card.querySelector('a.grid-product__link');
    if (!row || !link || !getForm(root)) return;
    const title = (card.querySelector('.grid-product__title') || link).textContent.trim();
    const check = document.createElement('input');
    check.type = 'checkbox';
    check.className = 'rc-addon-check';
    check.disabled = true;
    check.setAttribute('aria-label', 'Tilføj 1 × ' + title + ' sammen med hovedproduktet');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rc-addon-add';
    button.disabled = true;
    button.setAttribute('aria-label', 'Læg 1 × ' + title + ' i kurven');
    button.title = 'Læg i kurv';
    button.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 3h2l2.5 12h10L20 7H6"/><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>';
    const state = { check, button, variantId: null };
    states.set(card, state);
    row.classList.add('rc-addon-row');
    row.prepend(check);
    row.append(button);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (state.variantId) add(root, getForm(root), button, [state], false);
    });
    try {
      const product = await productFor(card);
      // Never silently select a size/colour or a subscription on the shopper's behalf.
      const variant = product.variants && product.variants.length === 1 && product.variants[0];
      const rule = variant && variant.quantity_rule;
      const canAddOne = !rule || ((rule.min || 1) === 1 && (rule.increment || 1) === 1 && (rule.max == null || rule.max >= 1));
      if (variant && variant.available && !product.requires_selling_plan && canAddOne) {
        state.variantId = variant.id;
        check.disabled = button.disabled = busy || needsReview;
      } else {
        check.hidden = true;
        button.hidden = true;
        const choose = document.createElement('a');
        choose.className = 'rc-addon-choose';
        choose.href = link.href;
        choose.textContent = !product.available ? 'Se produkt' : 'Vælg';
        choose.setAttribute('aria-label', 'Se valgmuligheder for ' + title);
        row.append(choose);
      }
    } catch (_) {
      check.hidden = true;
      button.hidden = true;
      // Product link remains available; do not display a non-working cart control.
    }
    resize(root);
  }

  function init() {
    document.querySelectorAll(ROOT).forEach(root => {
      root.querySelectorAll('.grid-product[data-product-id]').forEach(card => enhance(card, root));
    });
  }

  document.addEventListener('submit', function (event) {
    const root = document.querySelector(ROOT);
    if (!root) return;
    const form = getForm(root);
    if (!form || event.target !== form) return;
    const selected = [...root.querySelectorAll('.grid-product[data-product-id]')]
      .map(card => states.get(card)).filter(state => state && state.variantId && state.check.checked);
    if (!selected.length && !busy && !needsReview) return; // Original Impulse flow.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || needsReview || !form.reportValidity()) return;
    const button = event.submitter || form.querySelector('[data-add-to-cart], button[type="submit"]');
    if (!button || button.disabled || button.classList.contains('btn--loading')) return;
    const unique = [...new Map(selected.map(state => [state.variantId, state])).values()];
    add(root, form, button, unique, true);
  }, true);

  document.addEventListener('recommendations:loaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* END RITTENCOM RECOMMENDATION ADDONS 2026-09-08 */
